// extracted by mini-css-extract-plugin
export default {"modal":"XsmyN","content":"GHewP","title":"VsymC","text":"xBqB6","closeButton":"n6C2H","background":"Z1m0_"};